function capitalizeFirstLetter(string) {
  string = string.toLowerCase();
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const WINDOWS_VERSIONS = {
  0: "Any",
  7601: "Windows 7",
  9200: "Windows 8",
  9600: "Windows 8.1",
  10240: "Windows 10 1507",
  10586: "Windows 10 1511",
  14393: "Windows 10 1607",
  15063: "Windows 10 1703",
  16299: "Windows 10 1709",
  17134: "Windows 10 1803",
  17763: "Windows 10 1809",
  18362: "Windows 10 1903",
  18363: "Windows 10 1909",
  19041: "Windows 10 2004",
  19042: "Windows 10 20H2",
  19043: "Windows 10 21H1",
  19044: "Windows 10 21H2",
  19045: "Windows 10 22H2",
  22000: "Windows 11 21H2",
  22621: "Windows 11 22H2",
};

function getSupportedVersions(product) {
  const min = product.minSupportedWinBuild;
  const max = product.maxSupportedWinBuild;

  if (min === 0 && max === 0) {
    return Object.values(WINDOWS_VERSIONS);
  }

  let result = [];
  for (const key in WINDOWS_VERSIONS) {
    if (key >= min && key <= max) {
      result.push(WINDOWS_VERSIONS[key]);
    }
  }
  return result;
}

export { capitalizeFirstLetter, getSupportedVersions, WINDOWS_VERSIONS };
